export default {
  colors: {
    primary: '#44B04F',
    primary95: 'rgba(68, 176, 79, 0.95)',
    secondary: '#EBF5EC',
    tertiary: '#4C7B4D',
    quaternary: '#282725',
    quinary: '#5A625E',
    senary: '#293040',
    septenary: '#ADB0BA',
    success: '#31ac55',
    primaryBackground: '#FFFFFF',
    secondaryBackground: '#EBF5EC',
    tertiaryBackground: '#44B04F',
    quaternaryBackground: '#eaf1ff',
    quinaryBackground: '#e1ecff',
    lightNeutral: '#ffffff',
    darkNeutral: '#282725',
    mediumNeutral: '#5A625E',
    primaryShade: '#282726',
    secondaryShade: '#54504C',
    tertiaryShade: '#86817C',
    quaternaryShade: '#D6CAB0',
    bankOfLithuania: '#B3C5BF',
    disabledButton: '#D3D3D3',
    error: '#D35549',

    navigationPrimaryText: '#5A625E',
    navigationSecondaryText: '#233143',
    navigationPrimaryBackground: '#FFFFFF',
    navigationSecondaryBackground: '#FFFFFF',
    modes: {
      light: {
        navigationPrimaryText: '#233143',
        navigationPrimaryBackground: '#FFFFFF',
      },
    },
  },
  fonts: {
    body: "'Open Sans', sans-serif",
    heading: "'Open Sans', sans-serif",
  },
  fontWeights: {
    normal: 400,
    semibold: 600,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
    title: 1.22,
    subtitle: 1.56,
    normal: 1.2,
    submenu: 1.44,
    subtitleprimary: 1.25,
    subtitlesecondary: 1.17,
    subtitletertiary: 1.26,
    textprimary: 1.63,
    comfortable: 3,
  },
  fontSizes: [
    '12px', // 0
    '14px', // 1
    '16px', // 2
    '18px', // 3
    '20px', // 4
    '24px', // 5
    '32px', // 6
    '36px', // 7
    '40px', // 8
    '48px', // 9
  ],
  space: [
    '0', // 0
    '4px', // 1
    '8px', // 2
    '12px', // 3
    '14px', // 4
    '16px', // 5
    '18px', // 6
    '24px', // 7
    '32px', // 8
    '40px', // 9
    '44px', // 10
    '48px', // 11
    '56px', // 12
    '64px', // 13
    '80px', // 14
    '128px', // 15
    '256px', // 16
    '512px', // 17
  ],
  sizes: {
    container: '100%',
  },
  radii: ['0', '2px', '4px', '8px', '16px'],
  display: {
    none: 'none',
    inherit: 'inherit',
  },
  breakpoints: ['320px', '640px', '768px', '1024px', '1280px'],
  // Variants
  text: {
    heading: {
      fontWeight: 'bold',
      lineHeight: 'heading',
    },
    heroTitle: {
      py: 8,
      variant: 'text.heading',
      fontSize: [8, 8, 8, 9],
      lineHeight: 'heading',
    },
    sectionTitle: {
      py: 6,
      variant: 'text.heading',
      fontSize: [7, 7, 7, 9],
      color: 'quaternary',
    },
    sectionSubtitle: {
      pt: 8,
      pb: [11, 11, 11, 13, 13],
      lineHeight: 'heading',
      fontWeight: '400',
      fontSize: [3, 3, 3, 4],
      color: 'mediumNeutral',
    },
    contentTitle: {
      variant: 'text.heading',
      fontSize: 4,
      color: 'primary',
    },
    contentTitleLight: {
      py: 3,
      variant: 'text.heading',
      fontSize: 3,
      color: 'tertiary',
    },
    content: {
      py: 2,
      fontSize: 3,
      color: 'quaternary',
    },
    underHero: {
      display: 'block',
      fontSize: [1, 1, 1, 3],
      color: 'quinary',
      fontWeight: 'normal',
    },
    underContent: {
      fontSize: 2,
      color: 'quinary',
      fontWeight: 'normal',
      display: 'block',
      textAlign: 'justify'
    },
    underContentLight: {
      fontSize: 2,
      color: 'tertiary',
      fontWeight: ['semibold', 'normal'],
      textAlign: 'justify'
    },
    smallReferences: {
      fontSize: 1,
      fontWeight: 'normal',
    },
  },
  buttons: {
    default: {
      display: 'inline-flex',
      borderRadius: '22px',
      paddingTop: 3,
      paddingBottom: 3,
      paddingX: 7,
      lineHeight: 'subtitleprimary',
      minWidth: 'auto',
      fontFamily: 'body',
      fontSize: 2,
      fontWeight: 'semibold',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    primary: {
      variant: 'buttons.default',
      color: 'lightNeutral',
      bg: 'primary',
    },
    secondary: {
      variant: 'buttons.default',
      color: 'primary',
      bg: 'primaryBackground',
      border: '0px',
      borderColor: 'primaryBackground',
      borderStyle: 'solid',
    },
    dark: {
      variant: 'buttons.default',
      color: 'tertiary',
      bg: 'quaternary',
    },
  },
  forms: {
    input: {
      paddingY: 5,
      paddingX: 4,
      borderRadius: 2,
      marginRight: 2,
      fontSize: 1,
      lineHeight: 'normal',
      display: 'inline-block',
      '&::placeholder': {
        fontSize: 4,
      },
    },
    select: {
      fullWidth: {
        width: '100%',
      },
    },
  },
  container: {
    px: ['20px', 5],
  },
  heading: {
    color: 'tertiary',
    fontFamily: 'heading',
    fontSize: [34, 40, 46],
    width: ['275px', '335px', '532px'],
    pl: ['20px', '20px', '151px'],
  },
  subtitle: {
    color: 'tertiary',
    fontFamily: 'heading',
    fontSize: [16, 16, 18],
    width: ['275px', '335px', '531px'],
    pl: ['20px', '20px', '151px'],
    pt: ['20px', '20px', '24px'],
  },
  styles: {
    root: {
      fontFamily: 'body',
      lineHeight: 'body',
      fontWeight: 'normal',
      backgroundColor: 'primaryBackground',
    },
    a: {
      textDecoration: 'none',
      color: 'primary',
      transition: 'all 0.2s ease-in',
      '&:hover': {
        opacity: '0.8',
      },
    },
  },
};